import React, { useState, useEffect } from "react";
import { MdOutlineClose } from "react-icons/md";


function AddUpdateModal({ onClose, formData, type, handleChange, onSubmit }) {

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) onSubmit();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50">

      {/* Modal */}
      <div className="bg-white w-full max-w-2xl rounded-lg shadow-lg">

        {/* Header */}
        <div className="flex justify-between items-center border-b border-gray-300 px-6 py-4">
          <h2 className="text-lg font-semibold">
            {type + " Case Study"}
          </h2>

          <button
            onClick={onClose}
            className="textblack hover:text-gray-500"
          >
            <MdOutlineClose size={24} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>

          <div className="p-6 space-y-4">

            {/* Name */}
            <div>
              <label className="block text-base font-medium textblack mb-1">
                Name
              </label>
              <input
                type="text"
                name="name"
                value={formData.name || ""}
                onChange={handleChange}
                className="w-full textblack border border-gray-300 rounded-md px-3 py-2 focus:outline-none"
                placeholder="Enter name"
                required
              />
            </div>

            {/* Description */}
            <div>
              <label className="block text-base font-medium textblack mb-1">
                Description
              </label>
              <textarea
                name="desc"
                value={formData.desc || ""}
                onChange={handleChange}
                rows="4"
                className="w-full textblack border border-gray-300 rounded-md px-3 py-2 focus:outline-none"
                placeholder="Enter description"
              />
            </div>

          </div>

          {/* Footer */}
          <div className="flex justify-end gap-3 border-t border-gray-300 px-6 py-4">

            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-indigo-600 border border-gray-300 rounded-md hover:bg-indigo-100"
            >
              Cancel
            </button>

            <button
              type="submit"
              className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-md"
            >
              {type}
            </button>

          </div>

        </form>

      </div>
    </div>
  );
}

export default AddUpdateModal;